import { pubSub } from '@utils/PubSub';
import Cookies from 'js-cookie';
import { ugcVideo } from '@utils/global-functions';

export default class CipaBanner {
  constructor(context) {
    this.elements = {
      container: context,
      copy: context.querySelector('.cipa-banner--copy > div'),
      cta: context.querySelector('.cipa-banner--cta button'),
      close: context.querySelector('.cipa-banner--close'),
    };
    this.awaitDY();
  }
  awaitDY() {
    pubSub.subscribe('dy:cookiePref:init', () => {
      const data = window.Brooklinen?.cipa[0];
      if (data) {
        ugcVideo('hide');
        this.updateCipaBanner(data);
        this.initEventListeners();
      }
    });
  }

  initEventListeners() {
    const { close, cta } = this.elements;
    cta.addEventListener('click', () => {
      this.closeCipaBanner();
      this.setCipaCookie();
    });
    close.addEventListener('click', () => {
      this.closeCipaBanner();
    });
  }
  updateCipaBanner(data) {
    const { copy, cta, container } = this.elements;
    copy.innerHTML = data?.copy;
    cta.innerHTML = data?.cta;
    container?.setAttribute('data-open', true);
  }
  closeCipaBanner() {
    const { container } = this.elements;
    container?.removeAttribute('data-open');
    ugcVideo('show');
  }
  setCipaCookie() {
    Cookies.set('_bl_prod__dy_cookies_accept', true, {
      expires: window.Brooklinen?.cipa.expires || 30,
    });
  }
}
